import React from 'react';
import { getValueSafely } from 'utils/utils';
import errorIcon from 'assets/icons/error-2.svg';
import { LOW_BATTERY_THRESHOLD } from 'config/constants';
import TableCellWarning from 'components/DataTable/cells/TableCellWarning';
import { format } from 'date-fns';
import { Beacon } from 'types/beacon';

export default function BatterySpan({ beacon }: { beacon: Beacon }) {
  if (!beacon || !beacon.battery) return <>––</>;
  const hasTimestamp = beacon.last_location_update_timestamp !== null;

  if (beacon.battery <= LOW_BATTERY_THRESHOLD) {
    return (
      <TableCellWarning>
        {getValueSafely(beacon.battery, '%')}
        <img
          style={{
            marginLeft: '13px',
            width: '20px',
          }}
          src={errorIcon}
          alt="low battery"
        />
        {hasTimestamp && (
          <span style={{ color: 'black', marginLeft: '10px' }}>
            {`  (${format(new Date(beacon.last_location_update_timestamp || ""), 'dd/MM/yyyy - HH:mm')})`}
          </span>
        )}
      </TableCellWarning>
    );
  } else {
    return (
      <span className="u-no-pointer-event">
        {getValueSafely(beacon.battery, '%')}
        {hasTimestamp && (
          <span style={{ color: 'black', marginLeft: '10px' }}>
            {`  (${format(new Date(beacon.last_location_update_timestamp || ""), 'dd/MM/yyyy - HH:mm')})`}
          </span>
        )}
      </span>
    );
  }
}
